import { render, staticRenderFns } from "./VoucherRamadhan.vue?vue&type=template&id=6e706cf4&"
import script from "./VoucherRamadhan.vue?vue&type=script&lang=js&"
export * from "./VoucherRamadhan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports